/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Blog_Category_DescriptionInputs */

const en_blog_category_description = /** @type {(inputs: Blog_Category_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} on the Complete Athlete blog.`)
};

const pl_blog_category_description = /** @type {(inputs: Blog_Category_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} na blogu Complete Athlete.`)
};

/**
* | output |
* | --- |
* | "{name} on the Complete Athlete blog." |
*
* @param {Blog_Category_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_category_description = /** @type {((inputs: Blog_Category_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Category_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_category_description(inputs)
	return en_blog_category_description(inputs)
});